import { Header } from '../../components/header'
import { AuthLayoutSection } from '../../components/authLayoutSection'
import { MainContent } from '../../components/mainContent'

export const MainPage = ()  => (
    <>
        <Header rating={true} game={false} logo={true}/>
        <main>
            <AuthLayoutSection game={false}>
                <MainContent/>
            </AuthLayoutSection>
        </main>
    </>
)